<template>
  <div class="rst-review">
    <div class="rst-review__row">
      <span class="rst-review__label">Partner</span>
      <span class="rst-review__value">{{ context.partnerName }}</span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Period</span>
      <span class="rst-review__value">{{ context.periodLabel }}</span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Total Revenue</span>
      <span class="rst-review__value">{{ currency(context.totalRevenue) }}</span>
    </div>
    <div v-if="context.totalPartnerShare !== null" class="rst-review__row">
      <span class="rst-review__label">Partner Share</span>
      <span class="rst-review__value rst-review__value--success">
        {{ currency(context.totalPartnerShare) }}
      </span>
    </div>

    <v-divider class="my-2"></v-divider>

    <div class="rst-review__row">
      <span class="rst-review__label">Transaction ID</span>
      <span class="rst-review__value">{{ transaction.transaction_id || "—" }}</span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Transaction Date</span>
      <span class="rst-review__value">{{ transaction.transaction_date || "—" }}</span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Bank</span>
      <span class="rst-review__value">{{ transaction.bank_name || "—" }}</span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Account</span>
      <span class="rst-review__value">
        {{ maskAccountNumber(transaction.bank_account_number) }}
      </span>
    </div>
    <div class="rst-review__row">
      <span class="rst-review__label">Mode</span>
      <span class="rst-review__value">{{ transaction.payment_mode || "—" }}</span>
    </div>
    <div v-if="transaction.remarks" class="rst-review__row">
      <span class="rst-review__label">Remarks</span>
      <span class="rst-review__value">{{ transaction.remarks }}</span>
    </div>
  </div>
</template>

<script>
import { currency, maskAccountNumber } from "./transaction";

export default {
  name: "RevenueSplitTransactionReview",

  props: {
    context: { type: Object, required: true },
    transaction: { type: Object, required: true },
  },

  methods: { currency, maskAccountNumber },
};
</script>

<style scoped>
.rst-review {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rst-review__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 13px;
}

.rst-review__label {
  color: #667085;
}

.rst-review__value {
  color: #101828;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.rst-review__value--success {
  color: #12805c;
}
</style>
